import { TopicElementModelAsEditor } from '../../graphql/private/PrivateSchemaTypes'
import React, { createContext, Dispatch, SetStateAction } from 'react'
import { TopicModelAsEditorWithFeedbacksCount } from './TopicEditPage'

interface ITopicEditingContext {
  updateElement: (
    elementId: number,
    elementData: Partial<TopicElementModelAsEditor>
  ) => any
  setTopic: Dispatch<SetStateAction<TopicModelAsEditorWithFeedbacksCount>>
  topic: TopicModelAsEditorWithFeedbacksCount
  setCurrentElementIndex: React.Dispatch<React.SetStateAction<number | null>>
  setPowerPointImportModalVisible: React.Dispatch<React.SetStateAction<boolean>>
}

export const TopicEditingContext = createContext<ITopicEditingContext>(
  null as any as ITopicEditingContext
)
